import _ from 'lodash';
import getPackageChanges from './getPackageChanges';
import getSpecialServicesChanges from './getSpecialServicesChanges';
import getPassengerInsuranceChanges from './getPassengerInsuranceChanges';
import getCruiseTransportChanges from './getCruiseTransportChanges';
import getDiningChanges from './getDiningChanges';
import { TravelTypes } from '../../../constants';

const getTripConfirmationChanges = (
  passengers,
  addPaymentMethodToTravelTypes,
  trip,
  tripConfirmation,
) => {
  const travelers = Object.values(passengers);
  const originalPassengers = tripConfirmation.travelers;
  const packageChanges = getPackageChanges(travelers, originalPassengers);
  const servicesChanges = getSpecialServicesChanges(travelers, originalPassengers);
  const insuranceChanges = getPassengerInsuranceChanges(travelers, originalPassengers);
  const cruiseTransportChanges = getCruiseTransportChanges(travelers, originalPassengers);

  const cruiseItinerary = trip && trip.cruiseItinerary;
  const originalCruiseItinerary =
    tripConfirmation &&
    tripConfirmation.trip &&
    (_.find(tripConfirmation.trip.tripSegments, (ts) => ts.mode === TravelTypes.cruise) || {})
      .itinerary;
  const diningChanges = getDiningChanges(cruiseItinerary, originalCruiseItinerary);

  const doAddPaymentMethod =
    addPaymentMethodToTravelTypes && Object.values(addPaymentMethodToTravelTypes).length > 0;
  let hasChanges =
    packageChanges.length > 0 ||
    servicesChanges.length > 0 ||
    insuranceChanges.length > 0 ||
    cruiseTransportChanges.length > 0 ||
    diningChanges.length > 0;
  const doOnlyAddPaymentMethod = !hasChanges && doAddPaymentMethod;
  hasChanges = hasChanges || doAddPaymentMethod;
  return {
    packageChanges,
    servicesChanges,
    insuranceChanges,
    cruiseTransportChanges,
    doAddPaymentMethod,
    doOnlyAddPaymentMethod,
    hasChanges,
    diningChanges,
  };
};

export default getTripConfirmationChanges;
